export const globalConfig = {
  isProduction: process.env.NODE_ENV === 'production',
  projectName: process.env.NEXT_PUBLIC_PROJECT_NAME,
  originAgentsUrl: process.env.NEXT_PUBLIC_AGENTS_URL || '',
  originWebUrl: process.env.NEXT_PUBLIC_WEB_URL || '',
  baseUrl: process.env.NEXT_PUBLIC_BASE_URL || '',
  baseImageUrl: process.env.NEXT_PUBLIC_BASE_IMAGE_URL || '',
  natsServers: process.env.NEXT_PUBLIC_WS
    ? [process.env.NEXT_PUBLIC_WS]
    : process.env.NEXT_PUBLIC_NATS_SERVERS
      ? process.env.NEXT_PUBLIC_NATS_SERVERS.split(',').map((s) => s.trim())
      : ['wss://demo.nats.io:8443'],
  websocketUrl: process.env.NEXT_PUBLIC_WS || 'wss://ws-dev.malekcloud.com',
  isAgents: process.env.NEXT_PUBLIC_BASE_URL?.includes('agents'),
  apiUrl: process.env.NEXT_PUBLIC_API_URL || '',
}
